import {
  changeEventStatus,
  deleteBuyer,
  deleteChallan,
  deleteMasterEvent,
  deletePurchase,
  getApproved,
  getBuyer,
  getChallan,
  getPurchase,
} from "_services";
import {
  ButtonHeading,
  CommonModal,
  CommonPagination,
  CustomPagination,
} from "components";
import BootstrapTable from "components/BootstrapTable";
import { AddEventModal } from "modals";
import MastersFilterModal from "modals/MastersFilterModal";
import React, { useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import LoadingBar from "react-top-loading-bar";
import { UserContext } from "context";
import { useDispatch } from "react-redux";
import AddBuyerModal from "modals/AddBuyerModal/AddBuyerModal";
import { utils } from "helper";

const Challan = () => {
  const { masterData ,userType} = useContext(UserContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loadingBarRef = useRef(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [allEventList, setAllEventList] = useState([]);
  const [addressId, setAddressId] = useState("");
  const [eventView, setEventView] = useState(false);
  const [filter, setFilter] = useState({
    limit: 15,
    // offset: 1,
    // status: 1,
    challan_number: "",
    approved_by: "",
  });
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [prevPageUrl, setPrevPageUrl] = useState(null);
  const [allApproveList, setAllApproveList] = useState([]);
  const itemsPerPage = 15;
  const [totalItems, setTotalItems] = useState(0);

  const columns = [
    { header: "Challan Number", accessor: "challan_number" },
    { header: "Challan Out Date", accessor: "transactionDate" },
    { header: "Challan In Date", accessor: "transactionDateIn" },
    { header: "Aprroved By", accessor: "approved_by_name" },

    { header: "", accessor: "action" },
  ];

  useEffect(() => {
    getApproveList();
  }, []);

  useEffect(() => {
    getEventList();
  }, [filter]);

  const getEventList = async (url = null) => {
    try {
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart();
      }
      const filterParams = new URLSearchParams();

      Object.keys(filter).forEach((key) => {
        if (filter[key]) {
          filterParams.append(key, filter[key]);
        }
      });

      const urlmodify = `${url}?${filterParams.toString()}`;
      const res = await getChallan(url, filterParams.toString());

      if (res?.status === 200) {
        setAllEventList(res?.results);
        setNextPageUrl(res?.next);
        setPrevPageUrl(res?.previous);
        setTotalItems(res?.count);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      if (loadingBarRef.current) {
        loadingBarRef.current.complete();
      }
    }
  };

  const getApproveList = async (url = "") => {
    try {
      const res = await getApproved(url);

      if (res?.status === 200) {
        const list = res?.results?.map((i) => {
          return {
            ...i,
            label: i?.name,
            value: i?.id,
          };
        });
        setAllApproveList(list);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

  const deleteHandler = (item) => {
    setIsDelete(item);
  };

  const statusChangeHnadle = async (data, index) => {
    const list = [...allEventList];
    try {
      const payload = {
        is_active: data?.is_active === true ? false : true,
      };
      const res = await changeEventStatus({ payload, id: data?.id });
      if (res?.status === 200) {
        getEventList();
      } else {
        setTimeout(() => {
          list[index].is_active = data?.is_active === true ? false : true;

          setAllEventList(list);
        }, 500);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleStatusEvent = async (data, index) => {
    statusChangeHnadle(data, index);
    const list = [...allEventList];
    list[index].is_active = data?.is_active === true ? false : true;
    setAllEventList(list);
  };

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      serial: (
        <React.Fragment>
          <div className="signDropdown">
            <button className="dropbtn11">
              <BsThreeDotsVertical />
            </button>
            <div className="dropdownContent">
              <Link
                to={`/stock/challan/create/${item?._id}`}
                // onClick={()=>{
                //   setEventView(item?.id)
                //   setAddressId(item?.id)
                //   setShowOffcanvas(true)
                // }}
                className="_avPointer"
                style={{ textDecoration: "none" }}
              >
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <AiOutlineEye />
                  </span>
                  &nbsp; View
                </span>
              </Link>
              <Link
                onClick={() => {
                  setAddressId(item?.id);
                  setShowOffcanvas(true);
                }}
                className="_avPointer"
                style={{ textDecoration: "none" }}
              >
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <FiEdit />
                  </span>
                  &nbsp; Edit
                </span>
              </Link>
              {/* <div
                    
                    className='_avPointer'
                  >
                    <span className='_samAnchor'>
                      <span className='editIcon_avt'>
                        <FiEdit />
                      </span>
                      Edit
                    </span>
                  </div> */}

              <div onClick={(e) => deleteHandler(item)} className="_avPointer">
                <span className="_samAnchor">
                  <span className="deleteIcon_avt">
                    <FaRegTrashCan color="red" />
                  </span>
                  Delete
                </span>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),

      supplier_name: (
        <Link style={{ textDecoration: "none" }}>
          {item?.company_user_name ? item?.company_user_name : "-"}
        </Link>
      ),
      contact_number: (
        <React.Fragment>
          {item?.user_id?.mobile_no ? item?.user_id?.mobile_no : "-"}
        </React.Fragment>
      ),
      category: (
        <React.Fragment>
          {
            masterData?.addressbook_category_list.find(
              (fx) => fx?.id == item?.category
            )?.name
          }
        </React.Fragment>
      ),
      party_group: (
        <React.Fragment>
          {item?.consignor_group_id?.name
            ? item?.consignor_group_id?.name
            : "-"}
        </React.Fragment>
      ),
      city: (
        <React.Fragment>
          {item?.city?.label ? item?.city?.label : "-"}
        </React.Fragment>
      ),
      transactionDate: (
        <>
          {item?.date_when_out
            ? utils?.formatDateMonth(item?.date_when_out)
            : "-"}{" "}
          |{" "}
          {item?.date_when_out
            ? utils?.getFormattedTime(item?.date_when_out)
            : "-"}
        </>
      ),
      transactionDateIn: (
        <>
          {item?.date_when_in
            ? utils?.formatDateMonth(item?.date_when_in)
            : "-"}{" "}
          |{" "}
          {item?.date_when_in
            ? utils?.getFormattedTime(item?.date_when_in)
            : "-"}
        </>
      ),
      status: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "125px" }}
        >
          {/* <input
            className="form-check-input"
            type="checkbox"
            name="actStatus"
            id={`actStatus-${item._id}`}
            autoComplete="off"
            checked={item?.is_active}
            // onChange={() => handleStatusEvent(item, i)}
            readOnly
          /> */}
          <span
            className={
              item?.is_active
                ? "active_label_masters_status"
                : "disabled_label_masters_status"
            }
          >
            {item?.is_active ? "Active" : "Expire"}
          </span>
        </div>
      ),
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "125px" }}
        >
          <span
            className="viewIcon_avt"
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate(`/store/challan/view/${item?.id}/${true}`);
            }}
          >
            <AiOutlineEye color="green" />
          </span>
          {userType!=4 &&<span
            className="viewIcon_avt"
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate(`/store/challan/edit/${item?.id}`);
            }}
          >
            <FiEdit color="blue" />
          </span>}
          {userType!=4 &&<span
            className="deleteIcon_avt"
            style={{ cursor: "pointer" }}
            onClick={(e) => deleteHandler(item)}
          >
            <FaRegTrashCan color="red" />
          </span>}
        </div>
      ),
      balance: item?.balance ? (
        <Link
          to={`/account/supplier/details/${item?._id}?tab=4`}
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              color:
                item.balance < 0
                  ? "#dc3545"
                  : item.balance > 0
                  ? "#28a745"
                  : "#1450ec",
            }}
          >
            <span></span>
            <span>{item.balance}</span>
          </div>
        </Link>
      ) : (
        <Link
          to={`/account/supplier/details/${item?._id}?tab=4`}
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              color: "#1450ec",
            }}
          >
            <span></span>
            <span>0</span>
          </div>
        </Link>
      ),
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }));
  };

  const submitDeleteSupplier = async () => {
    setLoading(true);
    try {
      loadingBarRef.current?.continuousStart();
      let object = {
        id: isDelete?.id,
      };

      const res = await deleteChallan(object);
      if (res?.status == 200) {
        toast.success(`${res?.message}`);

        setLoading(false);
        setIsDelete(false);
        getEventList();
      } else {
        toast.error(res?.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const handleNextPage = () => {
    if (nextPageUrl) {
      getEventList(nextPageUrl);
    }
  };

  const handlePrevPage = () => {
    if (prevPageUrl) {
      getEventList(prevPageUrl);
    }
  };

  const callBackNext = () => {
    handleNextPage();
  };

  const callBackPre = () => {
    handlePrevPage();
  };

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteSupplier,
    isLoadding: loading,
  };

  const callBack = () => {
    getEventList();
    setAddressId("");
    setEventView(false);
  };

  let eventProps = {
    isOpen: showOffcanvas,
    closeModal: (e) => {
      setAddressId("");
      setShowOffcanvas(false);
      setEventView(false);
    },

    modalMainClass: "_dashCommon_Modal _smModal",
    loading: loading,
    modalTitle: addressId
      ? eventView
        ? "View Buyer"
        : "Update Buyer"
      : "Add Buyer",
    submitTitle: addressId
      ? eventView
        ? "Buyer"
        : "Update Buyer"
      : "Add Buyer",
    callBack: callBack,
    addressId: addressId,
    eventView: eventView,
  };

  return (
    <div>
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />
      <ButtonHeading
        title={"Challan"}
        onClick={() => navigate("/store/challan/create")}
        buttonTitle={"Add Challan"}
        showSearchFilter={{
          challan_number: true,
          approved: true,
          search: false,
          // filterOption: true,
          filterCount: true,
        }}
        list={{
          approved: allApproveList,
        }}
        onClickFilterModal={(e) => setShowFilterModal(true)}
        filter={filter}
        setFilter={setFilter}
      />

      <div className="_tabWith_outTab">
        <BootstrapTable
          columns={columns}
          data={rowListData(allEventList?.length ? allEventList : [])}
          isLoading={loading}
        />

        {allEventList?.length > 0 && (
          <div className="paginationFt_avt ">
            {" "}
            <CommonPagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              handleNextPage={callBackNext}
              handlePrevPage={callBackPre}
            />
          </div>
        )}
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${
          showFilterModal ? "show" : ""
        }`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? "visible" : "hidden" }}
      >
        {showFilterModal && (
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
            name="Challan"
            isShow={{
              buyer_id: true,
              date_to: true,
              date_from: true,
              bill_number: true,
            }}
          />
        )}
      </div>
      <div className={showFilterModal ? "offBack_drop" : ""}></div>

      {isDelete?.id && (
        <CommonModal {...propsObject}>
          <p className="p-3">
            {" "}
            Do you really want to delete {isDelete?.event_name}{" "}
          </p>
        </CommonModal>
      )}

      {showOffcanvas && <AddBuyerModal {...eventProps} />}
    </div>
  );
};

export default Challan;
